import { BaseTestResultData } from "../Common/Testing/BaseTestResultData";
import { TestResultDataType } from "../Common/Testing/TestResultDataType";
import { TextMergeEditContext } from "./TextMergeEditContext";
import { TextMergeConfiguration } from "./TextMergeConfiguration";
import { BaseTestResultItem } from "../Common/Testing/BaseTestResultItem";

export class TextMergeTestResult extends BaseTestResultData {
    isShowResult: boolean = false;

    type: TestResultDataType = TestResultDataType.TEXT_MERGE;
    editContext?: TextMergeEditContext;

    textWithFields: string = "";

    private _definition?: TextMergeConfiguration;

    get definition(): TextMergeConfiguration | undefined {
        return this._definition;
    }

    set definition(definition: TextMergeConfiguration | undefined) {
        this._definition = definition;

        if (this._definition) {
            this.editContext = new TextMergeEditContext(this._definition);
        }
    }
}

export class TextMergeValueTestResult extends BaseTestResultItem {
    type: TestResultDataType = TestResultDataType.TEXT_MERGE_VALUE;
}
